import { useMediaQuery } from 'react-responsive'
 
const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1091 })
    return isTablet ? children : null
}

export default Tablet;